/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAtSignRtl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 1.406-.358 2.474-1.109 3.17-.738.686-1.664.83-2.391.83-.892 0-1.804-.377-2.473-1.036A5 5 0 1 1 15 8v-.9h2v5.4c0 .873.754 1.5 1.5 1.5.502 0 .826-.106 1.03-.295.193-.18.47-.611.47-1.705a8 8 0 1 0-8 8 7.96 7.96 0 0 0 4.8-1.6l1.201 1.6A9.96 9.96 0 0 1 12 22C6.477 22 2 17.523 2 12zm13 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAtSignRtl as AtSignRtl };
